export const ROW_HEIGHT = 82;
export const CAMPAIGN_NAME_COL_WIDTH = 300;
export const PLATFORM_COL_WIDTH = 140;
